import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import actions from 'actions'

export default combineReducers({
  meta: combineReducers({
    data: handleActions({
      [`${actions.media.readEvents}_FULFILLED`]: (state, action) => action.payload,
      [actions.media.setInitialState]: (state, action) => action.payload.meta.data
    }, []),
    isLoaded: handleActions({
      [`${actions.media.readEvents}_FULFILLED`]: () => true,
      [`${actions.media.readEvents}_REJECTED`]: () => false,
      [actions.media.setInitialState]: (state, action) => action.payload.meta.isLoaded,
      [actions.media.generateMetaForEdit]: (state, action) => action.payload.isLoaded || state
    }, false),
    isLoading: handleActions({
      [`${actions.media.readEvents}_FULFILLED`]: () => false,
      [`${actions.media.readEvents}_PENDING`]: () => true,
      [`${actions.media.readEvents}_REJECTED`]: () => false,
      [actions.media.setInitialState]: (state, action) => action.payload.meta.isLoading
    }, false),
    editData: handleActions({
      [actions.media.generateMetaForEdit]: (state, action) => {
        const newData = {}

        action.payload.data.forEach(item => {
          newData[action.payload.uniqueFunc()] = item
        })

        return newData
      },
      [actions.media.updateItem]: (state, action) => {
        return {
          ...state,
          [action.payload.id]: action.payload
        }
      },
      [actions.media.removeItem]: (state, action) => {
        const newState = { ...state }

        delete newState[action.payload.id]
        return newState
      },
      [actions.media.addItem]: (state, action) => {
        return {
          ...state,
          [action.payload.metaItem.id]: action.payload.metaItem
        }
      },
      [actions.media.setInitialState]: (state, action) => action.payload.meta.editData,
      [actions.media.updateMeta]: (state, action) => action.payload.meta
    }, {}),
    activeItem: handleActions({
      [actions.media.setActiveItem]: (state, action) => action.payload.activeItem,
      [actions.media.addItem]: (state, action) => action.payload.metaItem,
      [actions.media.updateItem]: (state, action) => action.payload,
      [actions.media.removeItem]: () => null,
      [actions.media.setInitialState]: (state, action) => action.payload.meta.activeItem
    }, null)
  }),
  player: combineReducers({
    isPlayerLoaded: handleActions({
      [actions.media.player.setPlayerLoaded]: (state, action) => action.payload.isPlayerLoaded,
      [actions.media.setInitialState]: (state, action) => action.payload.player.isPlayerLoaded
    }, false),
    playerElement: handleActions({
      [actions.media.player.setPlayerLoaded]: (state, action) => action.payload.playerElement,
      [actions.media.setInitialState]: (state, action) => action.payload.player.playerElement
    }, null),
    dts: handleActions({
      [actions.media.player.setCurrentDts]: (state, action) => action.payload.dts
    }, 0)
  }),
  notificationStatus: handleActions({
    [actions.media.setNotificationStatus]: (state, action) => action.payload.notificationStatus,
    [actions.media.setInitialState]: (state, action) => action.payload.notificationStatus
  }, null)
})



// WEBPACK FOOTER //
// ./src/reducers/media.js